import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { removeToast, addToast } from "@Components/Common/Toasts/toasts.slice";
import type { ToastItem } from "@Components/Common/Toasts/toasts.slice";

export const useToastContainer = () => {
  const dispatch = useDispatch();
  const toasts = useSelector((state: any) => state.toasts?.items || []) as ToastItem[];

  useEffect(() => {
    // 1. Listen for standard custom event 'toast'
    const handleToastEvent = (event: Event) => {
      const customEvent = event as CustomEvent<{
        message: string;
        type: 'success' | 'error' | 'info' | 'warning';
        duration?: number;
      }>;
      if (customEvent.detail) {
        dispatch(addToast(customEvent.detail));
      }
    };

    // 2. Attach global window helper for direct calling
    (window as any).showToast = (
      message: string,
      type: 'success' | 'error' | 'info' | 'warning' = 'info',
      duration?: number
    ) => {
      dispatch(addToast({ message, type, duration }));
    };

    window.addEventListener('toast', handleToastEvent);

    return () => {
      window.removeEventListener('toast', handleToastEvent);
      delete (window as any).showToast;
    };
  }, [dispatch]);

  const handleClose = (id: string) => {
    dispatch(removeToast(id));
  };

  return {
    toasts,
    handleClose,
  };
};
